<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    TÉRMINOS Y<br>CONDICIONES
                </p></h1>
            </div>
            <div class="privacy-content">
                <p class="date">
                    Fecha de última actualización: 24 de agosto de 2021
                </p>
                <p>
                    En el presente contrato de adhesión se describen los Términos y Condiciones (en adelante “Los
                    Términos”) del servicio de adquisición de soluciones de <span>Firma Autógrafa Digital</span> (en
                    adelante FAD) de
                    <span>MUUK TECHNOLOGIES S. DE R.L. DE C.V.</span> (en adelante FAD) y otros productos adicionales
                    relacionados
                    con ésta; que se ofertan y proveen a través de nuestra aplicación.
                    <br><br>
                    <span>GENERALES DEL PROVEEDOR</span>
                    <br><br>
                    <span>Proveedor:</span> MUUK TECHNOLOGIES S. DE R.L. DE C.V.<br>
                    <span>Domicilio:</span> Fuente de Pirámides # 1-604 Col. Lomas de Tecamachalco, Naucalpan, Estado de
                    México.<br>
                    <span>Correo electrónico de contacto:</span> fad.support@na-at.com.mx<br>
                    <span>Número de teléfono de contacto:</span> 800 2239 323
                    <br><br>
                    Si Usted accede a nuestra aplicación y/o adquiere alguno de nuestros productos o servicios, declara
                    ser mayor de edad, persona física en pleno ejercicio y goce de sus Derechos, y acepta los Términos
                    del presente contrato. En caso de no estar de acuerdo con los presentes Términos, Usted deberá
                    abstenerse de utilizar nuestra Plataforma Digital y/o adquirir los productos y servicios de FAD que
                    le son ofrecidos.
                    <br><br>
                    Respecto a las actualizaciones de los presentes Términos, le notificaremos previamente de los
                    cambios por correo electrónico, para que Usted pueda consultarlos y leerlos cuidadosamente antes de
                    comprar nuestros Productos, Servicios o Utilizar FAD.
                </p>
                <ol>
                    <li><span>Adquisición de los servicios de FAD y/o productos adicionales relacionados.</span>
                        <br><br>
                        <ol type="a">
                            Usted podrá navegar en nuestra Plataforma Digital de FAD, y adquirir servicios o productos
                            adicionales.
                            Descripción de nuestro servicio FAD: nuestro objetivo es brindar una plataforma para firmar
                            documentos en cualquier parte de la república mexicana y del mundo de forma digital y
                            eficiente. FAD ofrece la posibilidad de firmar de manera autógrafa documentos digitales a
                            través de medios electrónicos, perfectamente válida como medio de evidencia del
                            consentimiento, ya que se trata de una firma autógrafa plasmada en un medio electrónico,
                            funcionalmente equivalente al papel, por lo que cuenta con pleno valor jurídico.
                            Para contratar nuestro servicio es necesario que Usted descargue la aplicación móvil de FAD
                            disponible para sistemas operativos Android e IOS.
                            Deberá consultar nuestro <a [routerLink]="['/aviso-de-privacidad']">aviso de privacidad</a>,
                            posteriormente registrarse con el formulario que se le proporciona, seguido con la creación
                            de un perfil para que Usted sea identificado dentro de FAD, posteriormente deberá
                            seleccionar el servicio que desea contratar así como la vigencia del mismo, llevar a cabo el
                            pago correspondiente y empezar a usar el software FAD para realizar firmas autógrafas en
                            medios digitales.
                        </ol>
                        <ol type="a">
                            <br><span>GLOSARIO</span>
                            Se refiere a todas las mejoras, revisiones, parches, optimizaciones, arreglos,
                            modificaciones, copias, agregados o paquetes de mantenimiento, etc.
                            <br><br><span>Actualización(es)</span>
                            Application Programming Interface. Conjunto de funciones, procedimientos y rutinas diseñados
                            para ser utilizados por otro software.
                            <br><br><span>API</span> Es la evidencia legal de integridad de un documento en caso de
                            controversia, provista por un Proveedor de Servicios de Certificación acreditado ante la
                            autoridad mexicana Secretaría de Economía. Sirve como testigo del tiempo exacto en que se
                            generó el documento electrónico o Mensaje de Datos, de acuerdo con diversos ordenamientos
                            legales mexicanos. Es parte del cumplimiento de la Norma Oficial Mexicana 151-SCFI-2016.
                            <br><br><span>Constancia de Conservación NOM-151-SCFI</span>
                            Capacidad del Programa de Cómputo para recibir múltiples firmas ya sea en un mismo
                            dispositivo o bien en diversos dispositivos.
                            <br><br><span>Multifirma</span>
                            Capacidad del Programa de Cómputo para recibir múltiples firmas ya sea en un mismo
                            dispositivo o bien en diversos dispositivos.
                            <br><br><span>Programas o Servicios de Terceros</span>
                            Se refiere a sistemas computacionales, procesos, o servicios provistos por terceros
                            independientes a NA-AT cuyos elementos programas, procesos o servicios son utilizados
                            durante el procesamiento del Programa de Cómputo o los servicios profesionales para ello.
                            <br><br><span>Servicios</span>
                            Se refiere al uso y explotación de FAD®, para la captura de firmas autógrafas en
                            dispositivos electrónicos, utilizando infraestructura en “La Nube” para realización del
                            proceso remoto de Firmas Autógrafas y demás derivados del presente instrumento, así como la
                            obtención de una constancia de conservación en términos de la Norma Oficial Mexicana
                            NOM-151-SCFI-2016, la generación de un archivo descargable donde consta la firma y los
                            elementos multimedia que la acompañan.
                            <br><br><span>Usuario</span>
                            Se refiere a la(s) persona(s) que instalan o utilizan el Software en su propio nombre o que
                            utilizan legalmente una copia del Software; o, si se descarga o instala el Software en
                            nombre de una organización como, por ejemplo, un empleador, además, a la organización para
                            la que se descarga o instala el Software, y por el presente se declara que dicha
                            organización ha autorizado a dicha persona para que acepte el presente contrato y lo haga en
                            su nombre.
                            <br><br><span>Usuario Activo</span>
                            Se refiere a las personas que son usuarios en FAD y tienen una cuenta activa dentro de la
                            plataforma.
                            <br><br><span>Videofirma</span>
                            Se refiere a la acción por medio de la cual la aplicación activa funcionalidades del
                            dispositivo para realizar la grabación de una persona firmando, así como los rastros que
                            ésta realiza sobre la pantalla del dispositivo que tiene en su posesión al momento mismo de
                            realizar un autógrafo directamente con sus dedos.
                            <br><br><span>Videograbación</span>
                            Se refiere a la acción por medio de la cual la
                            aplicación activa funcionalidades del dispositivo para realizar la grabación de la voz de la
                            persona firmante.
                            <br><br><span>Visor de archivos .PDF y .FAD</span>
                            Herramienta web que permite a cualquier persona visualizar el contenido de los archivos .PDF
                            y .FAD para fines de auditoría, siempre y cuando cuenten con las credenciales para ello.
                            <br><br><span>Captura de identificación</span>
                            Se refiere a la fotografía de la identificación por ambos lados.
                            <br><br><span>OTP vía Whatsapp</span>
                            Se refiere al código de un solo uso que se envía por Whatsapp, para que el firmante abra el
                            documento a firmar en la app móvil o web.
                            <br><br><span>Sello de tiempo en Blockchain</span>
                            Se refiere a la evidencia escrita en Etherium que garantiza que el documento firmado se hizo
                            en un determinado momento y no será alterado.
                            <br><br><span>Versión WEB</span>
                            El firmante podrá realizar la firma de documentos desde cualquier navegador sin ninguna
                            aplicación previamente descargada al dispositivo.
                            <br><br><span>Captura de identificación y validación de firma</span>
                            Se refiere a la comparación entre la firma plasmada en la identificación y la firma hecha
                            con el dedo o lápiz óptico en el dispositivo del firmante.
                            <br><br><span>Comparación facial con video acuerdo</span>
                            Se refiere a la comparación facial del video obtenido del firmante con el que aparece en su
                            ID.
                        </ol>
                    </li>
                    <br>

                    <li><span>CONDICIONES DEL SERVICIO</span> <br><br>
                        <ol type="a">El servicio que ofrecemos es personal e intransferible y contempla el registro de
                            un solo usuario, si Usted desea incluir más usuarios dentro de la Contratación del Servicio
                            que se le otorga, contáctenos vía telefónica 800 2239 323 o Whatsapp a nuestro número +52
                            (55) 26659500, para una cotización personalizada dentro de nuestro horario de oficina 10:00
                            a.m. a 7:00 p.m.
                            <br><br>
                            <span>Servicios ofertados en FAD para personas físicas:</span>
                            <br><br>
                            <span>Suscripción mensual.</span><br><br>
                            Usted podrá adquirir el Servicio de suscripción mensual por el precio que aparece en nuestra
                            lista de precios. más I.V.A.,en nuestro sitio web <a [routerLink]="['/']">Fad Masivo</a> la
                            suscripción empezará a contar a partir del día en que se realiza la contratación y concluirá
                            hasta un día antes del mes siguiente del día en que fue contratado, al contratar la
                            suscripción mensual tendrá derecho sin límite de firmas a lo siguiente:
                            <br><br>
                            A. videofirma,
                            <br>
                            B. videoacuerdo,
                            <br>
                            C. constancia de conservación emitida por un prestador de Servicios de Certificación
                            autorizado con base en la NOM-151-SCFI-2016,
                            <br>
                            D. verificación por número de teléfono,
                            <br>
                            E. el soporte técnico de nivel 1 el cual se realizará con horario de oficina de 10:00 am. a
                            8:00 p.m.;
                            <br>
                            F. Usted podrá cancelar la suscripción mensual en cualquier momento, si desea no seguir
                            contratando nuestros servicios deberá solicitarnos su cancelación, ya que de no recibirla
                            seguiremos haciendo cargos periódicos a su tarjeta para la continuación del Servicio
                            contratado.
                            <br>
                            <br>
                            <span>Prepago con Vigencia Anual</span>
                            <br><br>
                            Nuestro servicio en plan de prepago tiene una vigencia anual y el costo de este dependerá
                            del número de firmas que desea realizar, contamos con los siguientes planes con los precios
                            que aparecen en nuestra lista de precios disponible en nuestro sitio web
                            <a [routerLink]="['/']">Fad Masivo</a>:
                            <br>
                            10 firmas
                            <br>
                            20 firmas
                            <br>
                            50 firmas
                            <br>
                            100 firmas
                            <br>
                            200 firmas
                            <br>
                            500 firmas y
                            <br>
                            1000 firmas
                            <br>
                            El periodo de vigencia anual iniciará a partir del día que Usted realiza la contratación y
                            finalizará cumpliendose los 365 días naturales; terminando dicho plazo usted no podrá
                            disponer de las firmas que no logró realizar o concretar en el periodo que se adquirió el
                            Servicio, Si Usted termina las firmas anticipadamente de la contratación del periodo anual,
                            se dará por concluida la contratación puesto que el objetivo del servicio de plan de prepago
                            anual es la prestación del servicio durante el tiempo estipulado anteriormente o cuando se
                            consuma dicha cantidad de firmas contratadas, lo que suceda primero.
                            <br>
                            Al contratar prepago con vigencia anual tendrá derecho a lo siguiente:
                            <br><br>
                            A. videofirma,<br>
                            B. videoacuerdo,<br>
                            C. constancia de conservación,<br>
                            D. verificación por número de teléfono.<br>
                            El pago correspondiente a prepago con vigencia anual se hará en una sola exhibición.<br><br>
                            <span>Productos Adicionales:</span><br><br>
                            En cualquier momento Usted podrá adquirir los siguientes Productos Adicionales que ofrece
                            FAD con un costo extra los cuales están descritos en el portal del Usuario, donde se
                            encuentra su precio unitario:<br>
                            A. captura de identificación,<br>
                            B. OTP vía Whatsapp,<br>
                            C. sello de tiempo en Blockchain,<br>
                            D. versión web,<br>
                            E. captura de identificación y validación de firma<br>
                            F. captura de identificación, validación de firma y comparación facial con video acuerdo<br>
                            G. captura de identificación, validación de firma, comparación facial con video acuerdo y
                            comparación facial con video firma.<br>
                            <br>
                            <p style="text-align: center; margin: 10px; font-weight: bold">
                                <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp" style="font-weight: bold;color: #262626; text-decoration: none; cursor: pointer;">Los addOns se venden por separado, para la compra contacta a un asesor de ventas.</a>
                            </p>
                        </ol>
                    </li>
                    <br>

                    <li><span>MÉTODO DE PAGO</span> <br><br>
                        <ol type="a">
                            Usted se compromete a pagar el precio del Servicio más impuestos relacionados y acepta los
                            diferentes métodos de pago que FAD le ofrece, para la suscripción del servicio incluyendo la
                            compra de productos adicionales, a su vez FAD le notificará previamente por medio de
                            nuestros canales de comunicación a Usted la actualización de los precios, si Usted no hace
                            manifestación alguna de inconformidad, Usted está aceptando pagar los precios actualizados y
                            cargos de la tarjeta de crédito o de débito u otros métodos de pago utilizados en relación
                            con una compra o contratación en nuestra aplicación.
                            <br>
                            Para brindarle nuestro servicio de forma mensual, si no procede el pago del servicio de FAD
                            se entenderá como no contratación y se le suspenderá el Servicio temporalmente hasta el
                            cumplimiento del pago.
                            <br>
                            FAD le enviará al correo electrónico dado de alta la confirmación y el recibo
                            correspondiente a la contratación de servicios o compra de productos, Si Usted desea
                            facturar nuestros servicios o compra de los productos de FAD, podrá solicitar la factura,
                            después de realizar la compra, deberá llenar el formulario con los datos correctos para
                            generar su factura y posteriormente nuestro equipo de FAD le enviará por correo electrónico
                            lo solicitado.
                            <br>
                            Por otra parte Usted podrá cancelar nuestro Servicio y/o producto dentro de los 5 días
                            hábiles siguientes a la contratación, sin responsabilidad ni penalización alguna de su
                            parte, reembolsando el precio pagado. Deberá solicitar la cancelación del presente contrato,
                            servicio y/o producto vía correo electrónico.
                            Es importante mencionar usted puede realizar el pago a través de la pasarela de pago
                            Conekta, al hacer uso de este medio de pago se sujeta a los términos y condiciones del
                            servicio y de reembolso de Conekta, por lo cual FAD no se hace responsable de los tiempos
                            estipulados y procedimiento que se encuentran en la página de conekta.
                            A través de esa plataforma Usted podrá realizar su pago de la siguiente manera: con tarjeta
                            de crédito o débito y/o pago en efectivo en las tiendas denominadas OXXO y/o pago por
                            transferencia bancaria.
                            <br>
                        </ol>
                    </li>
                    <br>

                    <li><span>PROCESO DE COMPRA</span> <br><br>
                        <ol type="a">
                            Una vez que Usted haya completado el pago, FAD le enviará a su correo electrónico dentro de
                            las 48 horas siguientes de la contratación, la confirmación de la compra y la clave de
                            acceso para el uso del FAD, así como video con la guía de uso del FAD y diagrama del proceso
                            de la firma autógrafa digital. El servicio podrá obtenerlo directamente de la página web con
                            su clave de acceso que le fue enviada; la información acerca del uso de la plataforma
                            digital estará disponible para su descarga en los sistemas operativos iOS y Android.
                            <br>
                            Los productos pueden cambiar o mejorar, es por eso que le mantendremos informado de las
                            actualizaciones de FAD, promociones del mes, de los nuevos servicios o mejoras y de nuevos
                            productos vía: teléfono, correo electrónico, Whatsapp, celular, en Nuestros Sitios y Redes
                            Sociales.
                        </ol>
                    </li>
                    <br>

                    <li><span>PROMOCIONES EN EL SITIO</span> <br><br>
                        <ol type="a">
                            En FAD ofrecemos diferentes promociones durante el año, nuestras promociones pueden ser
                            diferentes cada mes o año, por lo tanto FAD se compromete a difundir en nuestros canales de
                            comunicación (correo electrónico, redes sociales, télefono) las promociones mensuales o
                            anuales con términos y condiciones adicionales legibles y aplicables.
                        </ol>
                    </li>
                    <br>

                    <li><span>PRUEBA GATUITA</span> <br><br>
                        <ol type="a">
                            La prueba gratuita será aplicable para el usuario que se registre en nuestro portal y
                            consistirá en que podrá acceder a 3 transacciones de firma de manera mensual. Esta prueba
                            gratuita, sólo es aplicable durante el año 2021. Le permite a nuestros usuarios probar
                            nuestro servicio y tener la experiencia de uso de nuestra aplicación. Cuando esta promoción
                            expire, FAD se abstendrá de ofertar en el sitio web, esta promoción.
                            <br>
                            Para adquirir la prueba gratuita es necesario llenar el formulario de nombre y dirección de
                            correo electrónico sin información personal catalogada como datos financieros.
                            <br>
                            Promoción: Nuestra promoción 2021, es aplicable para personas físicas que adquieran en
                            prepago transacciones de firma, y consistirá en que se le hará entrega de 3 transacciones
                            extras por sobre las prepagadas. Solo aplicará para usuarios activos, es decir que hayan
                            adquirido una bolsa de transacciones.
                            <p style="text-align: center; margin: 10px; font-weight: bold">
                                "El plan de prueba gratuita incluye firma por medio de app nativa, videofirma y videoacuerdo, no incluye módulo para firma en web y addOns."
                            </p>
                        </ol>
                    </li>
                    <br>

                    <li><span>USUARIO EN NUESTROS SITIOS</span> <br><br>
                        <ol type="a">
                            Usted en calidad de Usuario tiene la responsabilidad de utilizar Nuestros Sitios de la misma
                            forma que fueron diseñados, se compromete a navegar en ellos de manera respetuosa, sin
                            violentar los derechos de propiedad intelectual u otros derechos propietarios de FAD.
                            Además, Usted se compromete a utilizar la información, contenido, servicios y productos de
                            manera lícita, sin contravenir lo dispuesto en los presentes Términos, la moral o el orden
                            público, y se abstendrá a realizar cualquier acto que pueda suponer una afectación a los
                            derechos de terceros o perjudique de algún modo el funcionamiento de Nuestros Sitios.
                            <br>
                            Así mismo, se compromete a proporcionar información lícita y veraz, en los formularios y
                            enlaces habilitados en Nuestros Sitios, para el Acceso o realizar la compra del producto y/o
                            servicio. El Usuario tendrá un canal de comunicación con FAD vía whatsapp por medio de un
                            enlace que proporciona la página web, donde se le brindará soporte técnico o aclaración del
                            funcionamiento de la App y/o comunicarse con el equipo de ventas de FAD con horario de 10:00
                            a.m. a 8:00 p.m. de lunes a viernes.
                        </ol>
                    </li>
                    <br>

                    <li><span>RECOPILACIÓN DE INFORMACIÓN Y PROTECCIÓN DE DATOS PERSONALES</span> <br><br>
                        <ol type="a">
                            Para FAD es muy importante cuidar su información personal que nos proporciona directamente
                            en nuestra página de internet y/o Plataforma Digital y/o Redes Sociales, con cumplimiento a
                            lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de
                            Particulares, su Reglamento y los demás lineamientos nacionales e internacionales en materia
                            de Protección de Datos Personales nos comprometemos a cumplir con las medidas de seguridad:
                            Físicas, Administrativas y Técnicas. E informándole que el tratamiento de sus datos
                            personales será con apego a los principios que la Ley Federal de Protección de Datos
                            Personales en Posesión de Particulares y su Reglamento establecen. (consulte nuestras
                            políticas de privacidad en https://fad.firmaautografa.com/#/aviso-de-privacidad/ ).
                            <br>
                            El tratamiento de los datos personales de las terceras personas con las que Usted haga uso
                            de nuestros servicios serán responsabilidad suya y dicho tratamiento se regirá por su propio
                            aviso de privacidad.
                            <br>
                            Nosotros (FAD) desempeñamos la función de responsable de los datos personales durante el
                            tiempo de procesamiento de la Firma, quedando liberado al momento mismo de la destrucción
                            (supresión o eliminación) de los datos personales en nuestras bases de datos. Usted está de
                            acuerdo con la destrucción (supresión o eliminación) de estos los datos personales que
                            fueron utilizados en el proceso de la Firma FAD, también se compromete a mantener en paz, a
                            salvo y sin responsabilidad de los Datos Personales a FAD del tratamiento que Usted le da a
                            la información de sus Clientes y/o Personas Autorizadas, este tratamiento comprende previo a
                            la firma, durante el proceso de la firma en el FAD y del tratamiento posterior a éste.
                            <br><br>
                            <span>Enlaces externos en Nuestros Sitios.</span>
                            <br><br>
                            En nuestro sitio web www.firmaautografa.com incluye hipervínculos o enlaces que de terceros
                            distintos a FAD, el objetivo principal de estos enlaces es mejorar la experiencia del
                            Usuario permitiéndole Acceder a nuestro portal a través de Redes Sociales para solicitar
                            información y/o soporte técnico del FAD (vía Whatsapp) y método de pago (conekta), por lo
                            cual tampoco se garantizará la disponibilidad, exactitud, veracidad, validez o legalidad de
                            los sitios externos; FAD no asume ningún tipo de responsabilidad por los daños y perjuicios
                            que pudieran ocasionar el acceso o uso, de los contenidos, productos o servicios disponibles
                            a través de los enlaces o hipervínculos que no sean gestionados por FAD.
                            <br><br>
                            <span>Cookies.</span>
                            <br><br>
                            Le informamos a Usted que al ingresar a nuestro sitio web recabamos cookies, que son
                            archivos de texto pequeños encriptados que se encuentran dentro de su navegador, en nuestro
                            sitio web ayudan al usuario a realizar ciertas funciones como el método de búsqueda o inicio
                            de sesión, recordando el usuario y contraseña dentro de su navegador, recordar los productos
                            en el carrito de compras, recomendarle productos o servicios de acuerdo a su perfil; las
                            cookies facilitan este proceso de manera rápida y eficiente.
                            <br><br>
                            Las cookies que recabamos son las siguientes: <br>
                            · Para el Acceso al portal.<br>
                            · Para su navegación en Nuestros Sitios.<br>
                            · De Identificación.<br>
                            · Para su seguridad.<br>
                            · De complemento (plug-in).<br>
                            · De análisis.<br>
                            · Publicitario.<br>
                            · Propiedad.<br>
                            <br>
                            En caso de que Usted no desee que se recopile su información de esta manera, deberá
                            rechazar, deshabilitar o eliminar el uso de las cookies en su navegador de internet, podrá
                            hacerlo de la siguiente manera siendo usuario de Safari o Google Chrome:<br><br>
                            • Ingrese a preferencias<br>
                            • Busque privacidad del navegador.<br>
                            • Desactive o bloquee las cookies de: www.firmaautografa.com<br>
                        </ol>
                    </li>
                    <br>

                    <li><span>POLÍTICA DE PROPIEDAD INTELECTUAL DENTRO DE NUESTROS SITIOS.</span> <br><br>
                        <ol type="a">
                            Se considerará propiedad exclusiva de FAD, el software, la página web, la plataforma
                            digital, el diseño, los productos adicionales, algoritmos, marcas, y cualquier otro derecho
                            de propiedad intelectual relacionado con el servicio o productos software motivo de este
                            contrato.
                            <br>
                            Usted tiene estrictamente prohibido realizar cualquier tipo de reproducción, copia, puesta a
                            disposición a terceros, modificación, des-compilación, ajustes o cualesquiera otros actos
                            que vulneren los derechos de propiedad intelectual de FAD. La manipulación del sistema
                            constituye una violación a la Ley Federal del Derecho de Autor y dará lugar al pago de daños
                            y perjuicios por tal motivo y eximirá a FAD de toda responsabilidad sobre las fallas que
                            presente el sistema como consecuencia de dichas modificaciones no autorizadas.
                            <br>
                            FAD en este acto otorga a Usted una garantía contra todo problema de carácter legal que
                            pudiera ocasionar un tercero con relación a la propiedad o derecho de autor sobre el
                            servicio del software y productos adicionales que se ofertan en nuestra página web y
                            plataforma digital, objeto del presente contrato. En caso de producirse esta eventualidad,
                            Usted dará aviso por escrito a FAD para que asuma las acciones legales pertinentes.
                        </ol>
                    </li>
                    <br>

                    <li><span>GARANTÍAS Y EXENCIÓN DE LA RESPONSABILIDAD DE FAD.</span> <br><br>
                        <ol type="a">
                            Además de las exenciones de responsabilidad que hemos determinado en los Términos, nosotros
                            no otorgamos responsabilidad o garantía alguna en los siguientes casos:
                            <br><br>
                            I. Usted podrá cancelar el servicio de FAD en cualquier momento, advirtiéndole que no habrá
                            reembolsos por la cancelación. En el caso de suspensión del servicio, Usted acepta que no
                            recibirá ningún reembolso o compensación alguna.
                            <br><br>
                            II. Las deficiencias de su dispositivo electrónico que no cuente con la capacidad suficiente
                            de soporte o tecnológicas de FAD.
                            <br><br>
                            III. La violación asociada por el uso indebido y/o alteración al FAD y/o Nuestros Sitios,
                            que pudiera provocar el mal funcionamiento a su dispositivo electrónico, así como el de
                            terceras personas, tal como los defectos, las fallas, abuso, los accidentes, la negligencia,
                            la instalación, operación o mantenimientos inadecuados, vandalismo informático, los hechos
                            de fuerza mayor, los actos de terrorismo; las interrupciones o sobrecargas en suministro
                            eléctrico, fallas en su servicio de Internet, hechas por Usted.
                            <br><br>
                            IV. La incompatibilidad causada por algún competente de hardware y/o software instalado en
                            sus dispositivos electrónicos. Usted se compromete a Actualizar la Plataforma Digital de
                            FAD, cada que le sea notificado a través de correo electrónico, teléfono móvil, teléfono
                            fijo, por Whatsapp, Sitio web o cualquier medio de sus nuevas mejoras o versiones.
                            <br><br>
                            V. El uso ilícito de la plataforma, FAD no se hace responsable de la firma de documentos
                            ilícitos que Usted realice dentro de FAD, nos eximimos de cualquier responsabilidad legal
                            por el uso indebido que Usted dé ilícitamente con terceras personas o su personal dentro de
                            la empresa, ya que nosotros no tenemos la visibilidad del contenido dentro de los
                            documentos, solo tenemos acceso a los datos personales durante el proceso de la firma por
                            motivo de validación de ésta.
                            <br><br>
                            VI. Nosotros brindamos el soporte técnico y garantía de nuestros servicios, por consiguiente
                            si Usted no puede realizar el proceso de firma autógrafa digital y/o los productos
                            adicionales que Usted adquirió, por problemas técnicos en Nuestros Sitios que puedan surgir
                            por nosotros, FAD procederá el descuento de la cantidad de las firmas que no pudieron
                            realizarse. Esta garantía será aplicable siempre y cuando Usted notifique previamente al
                            área de soporte Técnico de FAD; esta garantía será válida para la contratación del servicio
                            de prepago con vigencia anual.
                            <br><br>
                            VII. De igual manera en FAD ofreceremos garantía de nuestros servicios, en la contratación
                            del servicio de suscripción mensual, otorgándole un día más del servicio por la firma que
                            Usted no logró concretar por problemas técnicos en Nuestros Sitios que puedan surgir por
                            nosotros.
                        </ol>
                    </li>
                    <br>

                    <li><span>PROPIEDAD INTELECTUAL</span> <br><br>
                        <ol type="a">
                            a. Titulares de derechos: FAD, es la única y exclusiva titular de los derechos de propiedad
                            intelectual de las marcas, avisos comerciales, secretos industriales, modelos de utilidad,
                            patentes, obras protegidas por el derecho de autor de cualquier naturaleza, contenidos
                            escritos, digitales, audiovisuales, y en cualquier formato que existan en la APP, en
                            términos de la Ley Federal del Derecho de Autor.
                            <br><br>
                            b. Queda estrictamente prohibida la reproducción parcial o total por cualquier medio de los
                            contenidos, así como la divulgación a cualquier tercero.
                            <br><br>
                            c. Asimismo, se le informa al usuario que tanto la información proporcionada en la APP así
                            como las transacciones efectuadas a través de ésta, son tratadas de manera confidencial
                            conforme a la ley de protección de datos personales en posesión de particulares.
                            <br><br>
                            d. Exclusión de responsabilidad: Nuestra APP se encuentra disponible “tal cual”, por lo que
                            el usuario declara su conformidad respecto de las características y contenido presentes, por
                            lo tanto, FAD se exime de toda responsabilidad respecto de la indisponibilidad de las
                            conexiones, enlaces o sus contenidos por cuestiones que no le sean directamente imputables,
                            por ejemplo: fallas en el servicio de internet o de datos, ataques externos, desastres
                            naturales, causas de fuerza mayor o baja de contenidos, o fallas imputables a los terceros
                            proveedores de servicios de cómputo en la nube, proveedores externos en su calidad de
                            administradores de la plataforma o intermitencias en la conexión a los mismos.
                            <br><br>
                            e. Licencia: FAD, otorga al Usuario, en este acto, una licencia de uso, no exclusiva,
                            temporal y gratuita, respecto de la aplicación móvil, por lo que cualquier otro derecho
                            queda reservado a FAD y podrá ejercer las acciones legales correspondientes en caso de
                            cualquier violación a sus derechos de propiedad intelectual.
                            <br><br>
                            f. Prohibiciones expresas: Queda expresamente prohibido cualquier tipo de modificación o
                            alteración de los contenidos, código, información y materiales de la APP, técnicas de
                            ingeniería de reversa, copia o reproducción parcial o total del contenido, distribución o
                            comunicación pública de éste por cualquier medio o en cualquier formato.
                        </ol>
                    </li>
                    <br>

                    <li><span>SEGURIDAD INFORMÁTICA Y LIMITACIÓN A LA RESPONSABILIDAD:</span> <br><br>
                        <ol type="a">
                            La seguridad informática en el uso de la APP depende en gran medida de la seguridad de la
                            red
                            mediante la cual acceda a ésta, le recomendamos no conectarse a nuestra aplicación móvil
                            utilizando
                            servicios públicos de Internet.
                            <br><br>
                            Hacemos de su conocimiento que FAD se encuentra alojada en los servidores de un prestador de
                            servicios de cómputo en la nube que cumple con los más altos estándares en materia de
                            seguridad de
                            la información.
                            <br><br>
                            Se recomienda ampliamente instalar un antivirus y antimalware en su dispositivo móvil para
                            evitar
                            que personas malintencionadas ejecuten programas maliciosos que puedan poner en riesgo la
                            información contenida en su equipo y la de sus comunicaciones.
                        </ol>
                    </li>
                    <br>

                    <li><span>MODIFICACIONES O ACTUALIZACIONES.</span> <br><br>
                        <ol type="a">
                            FAD podrá en cualquier momento y cuando lo considere conveniente, realizar correcciones,
                            adiciones,
                            mejoras o modificaciones al contenido, presentación, información, servicios, y demás
                            elementos, sin
                            que ello dé lugar ni derecho a ninguna reclamación o indemnización, ni que lo mismo implique
                            reconocimiento de responsabilidad alguna a favor del Usuario.
                        </ol>
                    </li>
                    <br>

                    <li><span>CONFIDENCIALIDAD DE LA INFORMACIÓN:</span> <br><br>
                        <ol type="a">
                            FAD utilizará la información proporcionada por el usuario de forma confidencial, la cual no
                            será difundida o transmitida para fines distintos a los establecidos en el presente
                            contrato, salvo que exista autorización expresa por parte del usuario.
                        </ol>
                    </li>
                    <br>

                    <li><span>RECLAMACIONES Y/O SOLICITUDES DE ACLARACIÓN:</span> <br><br>
                        <ol type="a">
                            En caso de reclamación y/o solicitud de aclaración respecto de los servicios de FAD, se
                            informa al usuario que podrá contactarse vía correo electrónico o bien podrá acudir al
                            domicilio, señalados en el punto 1 “Generales del proveedor” de los presentes términos y
                            condiciones.
                        </ol>
                    </li>
                    <br>

                    <li><span>PRÁCTICAS COMERCIALES:</span> <br><br>
                        <ol type="a">
                            FAD, no lleva a cabo prácticas comerciales engañosas, respecto de las características de sus
                            servicios; el funcionamiento de esta APP es conforme a los fines para los cuales fue creado.
                        </ol>
                    </li>
                    <br>

                    <li><span>LEGISLACIÓN Y JURISDICCIÓN APLICABLE.</span> <br><br>
                        <ol type="a">
                            Para lo relativo con la interpretación y cumplimiento de los Términos, adicionalmente las
                            condiciones derivadas de las Leyes : Ley Federal del Derecho de Autor, Ley Federal de
                            Protección a la Propiedad Industrial, Ley Federal de Protección al Consumidor, Código de
                            Comercio y Código Civil, sometiéndose a las disposiciones aplicables y vigentes de las demás
                            Leyes Federales y la jurisdicción de los Tribunales Federales de la Ciudad de México,
                            renunciando a cualquier fuero que por razón de sus domicilios presentes o futuros o por
                            cualquier circunstancia les pudiere corresponder.
                        </ol>
                    </li>
                    <br>

                </ol>
                <br>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Términos y Condiciones</h1>
                <p class="text">
                    Fecha de última actualización: 24 de agosto de 2021
                </p>
                <p class="text">
                    En el presente contrato de adhesión se describen los Términos y Condiciones (en adelante “Los
                    Términos”) del servicio de adquisición de soluciones de <span>Firma Autógrafa Digital</span> (en
                    adelante FAD) de
                    <span>MUUK TECHNOLOGIES S. DE R.L. DE C.V.</span> (en adelante FAD) y otros productos adicionales
                    relacionados
                    con ésta; que se ofertan y proveen a través de nuestra aplicación.
                    <br><br>
                    <span>GENERALES DEL PROVEEDOR</span>
                    <br><br>
                    <span>Proveedor:</span> MUUK TECHNOLOGIES S. DE R.L. DE C.V.<br>
                    <span>Domicilio:</span> Fuente de Pirámides # 1-604 Col. Lomas de Tecamachalco, Naucalpan, Estado de
                    México.<br>
                    <span>Correo electrónico de contacto:</span> fad.support@na-at.com.mx<br>
                    <span>Número de teléfono de contacto:</span> 800 2239 323
                    <br><br>
                    Si Usted accede a nuestra aplicación y/o adquiere alguno de nuestros productos o servicios, declara
                    ser mayor de edad, persona física en pleno ejercicio y goce de sus Derechos, y acepta los Términos
                    del presente contrato. En caso de no estar de acuerdo con los presentes Términos, Usted deberá
                    abstenerse de utilizar nuestra Plataforma Digital y/o adquirir los productos y servicios de FAD que
                    le son ofrecidos.
                    <br><br>
                    Respecto a las actualizaciones de los presentes Términos, le notificaremos previamente de los
                    cambios por correo electrónico, para que Usted pueda consultarlos y leerlos cuidadosamente antes de
                    comprar nuestros Productos, Servicios o Utilizar FAD.
                </p>
                <ol class="text">

                    <li><span>Adquisición de los servicios de FAD y/o productos adicionales relacionados.</span>
                        <br><br>
                        <ol type="a">
                            Usted podrá navegar en nuestra Plataforma Digital de FAD, y adquirir servicios o productos
                            adicionales.
                            Descripción de nuestro servicio FAD: nuestro objetivo es brindar una plataforma para firmar
                            documentos en cualquier parte de la república mexicana y del mundo de forma digital y
                            eficiente. FAD ofrece la posibilidad de firmar de manera autógrafa documentos digitales a
                            través de medios electrónicos, perfectamente válida como medio de evidencia del
                            consentimiento, ya que se trata de una firma autógrafa plasmada en un medio electrónico,
                            funcionalmente equivalente al papel, por lo que cuenta con pleno valor jurídico.
                            Para contratar nuestro servicio es necesario que Usted descargue la aplicación móvil de FAD
                            disponible para sistemas operativos Android e IOS.
                            Deberá consultar nuestro <a [routerLink]="['/aviso-de-privacidad']">aviso de privacidad</a>,
                            posteriormente registrarse con el formulario que se le proporciona, seguido con la creación
                            de un perfil para que Usted sea identificado dentro de FAD, posteriormente deberá
                            seleccionar el servicio que desea contratar así como la vigencia del mismo, llevar a cabo el
                            pago correspondiente y empezar a usar el software FAD para realizar firmas autógrafas en
                            medios digitales.
                        </ol>
                        <ol type="a">
                            <br><span>GLOSARIO</span>
                            Se refiere a todas las mejoras, revisiones, parches, optimizaciones, arreglos,
                            modificaciones, copias, agregados o paquetes de mantenimiento, etc.
                            <br><br><span>Actualización(es)</span>
                            Application Programming Interface. Conjunto de funciones, procedimientos y rutinas diseñados
                            para ser utilizados por otro software.
                            <br><br><span>API</span> Es la evidencia legal de integridad de un documento en caso de
                            controversia, provista por un Proveedor de Servicios de Certificación acreditado ante la
                            autoridad mexicana Secretaría de Economía. Sirve como testigo del tiempo exacto en que se
                            generó el documento electrónico o Mensaje de Datos, de acuerdo con diversos ordenamientos
                            legales mexicanos. Es parte del cumplimiento de la Norma Oficial Mexicana 151-SCFI-2016.
                            <br><br><span>Constancia de Conservación NOM-151-SCFI</span>
                            Capacidad del Programa de Cómputo para recibir múltiples firmas ya sea en un mismo
                            dispositivo o bien en diversos dispositivos.
                            <br><br><span>Multifirma</span>
                            Capacidad del Programa de Cómputo para recibir múltiples firmas ya sea en un mismo
                            dispositivo o bien en diversos dispositivos.
                            <br><br><span>Programas o Servicios de Terceros</span>
                            Se refiere a sistemas computacionales, procesos, o servicios provistos por terceros
                            independientes a NA-AT cuyos elementos programas, procesos o servicios son utilizados
                            durante el procesamiento del Programa de Cómputo o los servicios profesionales para ello.
                            <br><br><span>Servicios</span>
                            Se refiere al uso y explotación de FAD®, para la captura de firmas autógrafas en
                            dispositivos electrónicos, utilizando infraestructura en “La Nube” para realización del
                            proceso remoto de Firmas Autógrafas y demás derivados del presente instrumento, así como la
                            obtención de una constancia de conservación en términos de la Norma Oficial Mexicana
                            NOM-151-SCFI-2016, la generación de un archivo descargable donde consta la firma y los
                            elementos multimedia que la acompañan.
                            <br><br><span>Usuario</span>
                            Se refiere a la(s) persona(s) que instalan o utilizan el Software en su propio nombre o que
                            utilizan legalmente una copia del Software; o, si se descarga o instala el Software en
                            nombre de una organización como, por ejemplo, un empleador, además, a la organización para
                            la que se descarga o instala el Software, y por el presente se declara que dicha
                            organización ha autorizado a dicha persona para que acepte el presente contrato y lo haga en
                            su nombre.
                            <br><br><span>Usuario Activo</span>
                            Se refiere a las personas que son usuarios en FAD y tienen una cuenta activa dentro de la
                            plataforma.
                            <br><br><span>Videofirma</span>
                            Se refiere a la acción por medio de la cual la aplicación activa funcionalidades del
                            dispositivo para realizar la grabación de una persona firmando, así como los rastros que
                            ésta realiza sobre la pantalla del dispositivo que tiene en su posesión al momento mismo de
                            realizar un autógrafo directamente con sus dedos.
                            <br><br><span>Videograbación</span>
                            Se refiere a la acción por medio de la cual la
                            aplicación activa funcionalidades del dispositivo para realizar la grabación de la voz de la
                            persona firmante.
                            <br><br><span>Visor de archivos .PDF y .FAD</span>
                            Herramienta web que permite a cualquier persona visualizar el contenido de los archivos .PDF
                            y .FAD para fines de auditoría, siempre y cuando cuenten con las credenciales para ello.
                            <br><br><span>Captura de identificación</span>
                            Se refiere a la fotografía de la identificación por ambos lados.
                            <br><br><span>OTP vía Whatsapp</span>
                            Se refiere al código de un solo uso que se envía por Whatsapp, para que el firmante abra el
                            documento a firmar en la app móvil o web.
                            <br><br><span>Sello de tiempo en Blockchain</span>
                            Se refiere a la evidencia escrita en Etherium que garantiza que el documento firmado se hizo
                            en un determinado momento y no será alterado.
                            <br><br><span>Versión WEB</span>
                            El firmante podrá realizar la firma de documentos desde cualquier navegador sin ninguna
                            aplicación previamente descargada al dispositivo.
                            <br><br><span>Captura de identificación y validación de firma</span>
                            Se refiere a la comparación entre la firma plasmada en la identificación y la firma hecha
                            con el dedo o lápiz óptico en el dispositivo del firmante.
                            <br><br><span>Comparación facial con video acuerdo</span>
                            Se refiere a la comparación facial del video obtenido del firmante con el que aparece en su
                            ID.
                        </ol>
                    </li>
                    <br>

                    <li><span>CONDICIONES DEL SERVICIO</span> <br><br>
                        <ol type="a">El servicio que ofrecemos es personal e intransferible y contempla el registro de
                            un solo usuario, si Usted desea incluir más usuarios dentro de la Contratación del Servicio
                            que se le otorga, contáctenos vía telefónica 800 2239 323 o Whatsapp a nuestro número +52
                            (55) 26659500, para una cotización personalizada dentro de nuestro horario de oficina 10:00
                            a.m. a 7:00 p.m.
                            <br><br>
                            <span>Servicios ofertados en FAD para personas físicas:</span>
                            <br><br>
                            <span>Suscripción mensual.</span><br><br>
                            Usted podrá adquirir el Servicio de suscripción mensual por el precio que aparece en nuestra
                            lista de precios. más I.V.A.,en nuestro sitio web <a [routerLink]="['/']">Fad Masivo</a> la
                            suscripción empezará a contar a partir del día en que se realiza la contratación y concluirá
                            hasta un día antes del mes siguiente del día en que fue contratado, al contratar la
                            suscripción mensual tendrá derecho sin límite de firmas a lo siguiente:
                            <br><br>
                            A. videofirma,
                            <br>
                            B. videoacuerdo,
                            <br>
                            C. constancia de conservación emitida por un prestador de Servicios de Certificación
                            autorizado con base en la NOM-151-SCFI-2016,
                            <br>
                            D. verificación por número de teléfono,
                            <br>
                            E. el soporte técnico de nivel 1 el cual se realizará con horario de oficina de 10:00 am. a
                            8:00 p.m.;
                            <br>
                            F. Usted podrá cancelar la suscripción mensual en cualquier momento, si desea no seguir
                            contratando nuestros servicios deberá solicitarnos su cancelación, ya que de no recibirla
                            seguiremos haciendo cargos periódicos a su tarjeta para la continuación del Servicio
                            contratado.
                            <br>
                            <br>
                            <span>Prepago con Vigencia Anual</span>
                            <br><br>
                            Nuestro servicio en plan de prepago tiene una vigencia anual y el costo de este dependerá
                            del número de firmas que desea realizar, contamos con los siguientes planes con los precios
                            que aparecen en nuestra lista de precios disponible en nuestro sitio web
                            <a [routerLink]="['/']">Fad Masivo</a>:
                            <br>
                            10 firmas
                            <br>
                            20 firmas
                            <br>
                            50 firmas
                            <br>
                            100 firmas
                            <br>
                            200 firmas
                            <br>
                            500 firmas y
                            <br>
                            1000 firmas
                            <br>
                            El periodo de vigencia anual iniciará a partir del día que Usted realiza la contratación y
                            finalizará cumpliendose los 365 días naturales; terminando dicho plazo usted no podrá
                            disponer de las firmas que no logró realizar o concretar en el periodo que se adquirió el
                            Servicio, Si Usted termina las firmas anticipadamente de la contratación del periodo anual,
                            se dará por concluida la contratación puesto que el objetivo del servicio de plan de prepago
                            anual es la prestación del servicio durante el tiempo estipulado anteriormente o cuando se
                            consuma dicha cantidad de firmas contratadas, lo que suceda primero.
                            <br>
                            Al contratar prepago con vigencia anual tendrá derecho a lo siguiente:
                            <br><br>
                            A. videofirma,<br>
                            B. videoacuerdo,<br>
                            C. constancia de conservación,<br>
                            D. verificación por número de teléfono.<br>
                            El pago correspondiente a prepago con vigencia anual se hará en una sola exhibición.<br><br>
                            <span>Productos Adicionales:</span><br><br>
                            En cualquier momento Usted podrá adquirir los siguientes Productos Adicionales que ofrece
                            FAD con un costo extra los cuales están descritos en el portal del Usuario, donde se
                            encuentra su precio unitario:
                            <br><br>
                            A. captura de identificación,<br>
                            B. OTP vía Whatsapp,<br>
                            C. sello de tiempo en Blockchain,<br>
                            D. versión web,<br>
                            E. captura de identificación y validación de firma<br>
                            F. captura de identificación, validación de firma y comparación facial con video acuerdo<br>
                            G. captura de identificación, validación de firma, comparación facial con video acuerdo y
                            comparación facial con video firma.<br>
                            <br>
                            <p style="text-align: center; margin: 10px; font-weight: bold">
                                <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp" style="font-weight: bold;color: #262626; text-decoration: none; cursor: pointer;">Los addOns se venden por separado, para la compra contacta a un asesor de ventas.</a>
                            </p>
                        </ol>
                    </li>
                    <br>

                    <li><span>MÉTODO DE PAGO</span> <br><br>
                        <ol type="a">
                            Usted se compromete a pagar el precio del Servicio más impuestos relacionados y acepta los
                            diferentes métodos de pago que FAD le ofrece, para la suscripción del servicio incluyendo la
                            compra de productos adicionales, a su vez FAD le notificará previamente por medio de
                            nuestros canales de comunicación a Usted la actualización de los precios, si Usted no hace
                            manifestación alguna de inconformidad, Usted está aceptando pagar los precios actualizados y
                            cargos de la tarjeta de crédito o de débito u otros métodos de pago utilizados en relación
                            con una compra o contratación en nuestra aplicación.
                            <br>
                            Para brindarle nuestro servicio de forma mensual, si no procede el pago del servicio de FAD
                            se entenderá como no contratación y se le suspenderá el Servicio temporalmente hasta el
                            cumplimiento del pago.
                            <br>
                            FAD le enviará al correo electrónico dado de alta la confirmación y el recibo
                            correspondiente a la contratación de servicios o compra de productos, Si Usted desea
                            facturar nuestros servicios o compra de los productos de FAD, podrá solicitar la factura,
                            después de realizar la compra, deberá llenar el formulario con los datos correctos para
                            generar su factura y posteriormente nuestro equipo de FAD le enviará por correo electrónico
                            lo solicitado.
                            <br>
                            Por otra parte Usted podrá cancelar nuestro Servicio y/o producto dentro de los 5 días
                            hábiles siguientes a la contratación, sin responsabilidad ni penalización alguna de su
                            parte, reembolsando el precio pagado. Deberá solicitar la cancelación del presente contrato,
                            servicio y/o producto vía correo electrónico.
                            Es importante mencionar usted puede realizar el pago a través de la pasarela de pago
                            Conekta, al hacer uso de este medio de pago se sujeta a los términos y condiciones del
                            servicio y de reembolso de Conekta, por lo cual FAD no se hace responsable de los tiempos
                            estipulados y procedimiento que se encuentran en la página de conekta.
                            A través de esa plataforma Usted podrá realizar su pago de la siguiente manera: con tarjeta
                            de crédito o débito y/o pago en efectivo en las tiendas denominadas OXXO y/o pago por
                            transferencia bancaria.
                            <br>
                        </ol>
                    </li>
                    <br>

                    <li><span>PROCESO DE COMPRA</span> <br><br>
                        <ol type="a">
                            Una vez que Usted haya completado el pago, FAD le enviará a su correo electrónico dentro de
                            las 48 horas siguientes de la contratación, la confirmación de la compra y la clave de
                            acceso para el uso del FAD, así como video con la guía de uso del FAD y diagrama del proceso
                            de la firma autógrafa digital. El servicio podrá obtenerlo directamente de la página web con
                            su clave de acceso que le fue enviada; la información acerca del uso de la plataforma
                            digital estará disponible para su descarga en los sistemas operativos iOS y Android.
                            <br>
                            Los productos pueden cambiar o mejorar, es por eso que le mantendremos informado de las
                            actualizaciones de FAD, promociones del mes, de los nuevos servicios o mejoras y de nuevos
                            productos vía: teléfono, correo electrónico, Whatsapp, celular, en Nuestros Sitios y Redes
                            Sociales.
                        </ol>
                    </li>
                    <br>

                    <li><span>PROMOCIONES EN EL SITIO</span> <br><br>
                        <ol type="a">
                            En FAD ofrecemos diferentes promociones durante el año, nuestras promociones pueden ser
                            diferentes cada mes o año, por lo tanto FAD se compromete a difundir en nuestros canales de
                            comunicación (correo electrónico, redes sociales, télefono) las promociones mensuales o
                            anuales con términos y condiciones adicionales legibles y aplicables.
                        </ol>
                    </li>
                    <br>

                    <li><span>PRUEBA GATUITA</span> <br><br>
                        <ol type="a">
                            La prueba gratuita será aplicable para el usuario que se registre en nuestro portal y
                            consistirá en que podrá acceder a 3 transacciones de firma de manera mensual. Esta prueba
                            gratuita, sólo es aplicable durante el año 2021. Le permite a nuestros usuarios probar
                            nuestro servicio y tener la experiencia de uso de nuestra aplicación. Cuando esta promoción
                            expire, FAD se abstendrá de ofertar en el sitio web, esta promoción.
                            <br>
                            Para adquirir la prueba gratuita es necesario llenar el formulario de nombre y dirección de
                            correo electrónico sin información personal catalogada como datos financieros.
                            <br>
                            Promoción: Nuestra promoción 2021, es aplicable para personas físicas que adquieran en
                            prepago transacciones de firma, y consistirá en que se le hará entrega de 3 transacciones
                            extras por sobre las prepagadas. Solo aplicará para usuarios activos, es decir que hayan
                            adquirido una bolsa de transacciones.
                            <p style="text-align: center; margin: 10px; font-weight: bold">
                                "El plan de prueba gratuita incluye firma por medio de app nativa, videofirma y videoacuerdo, no incluye módulo para firma en web y addOns."
                            </p>
                        </ol>
                    </li>
                    <br>

                    <li><span>USUARIO EN NUESTROS SITIOS</span> <br><br>
                        <ol type="a">
                            Usted en calidad de Usuario tiene la responsabilidad de utilizar Nuestros Sitios de la misma
                            forma que fueron diseñados, se compromete a navegar en ellos de manera respetuosa, sin
                            violentar los derechos de propiedad intelectual u otros derechos propietarios de FAD.
                            Además, Usted se compromete a utilizar la información, contenido, servicios y productos de
                            manera lícita, sin contravenir lo dispuesto en los presentes Términos, la moral o el orden
                            público, y se abstendrá a realizar cualquier acto que pueda suponer una afectación a los
                            derechos de terceros o perjudique de algún modo el funcionamiento de Nuestros Sitios.
                            <br>
                            Así mismo, se compromete a proporcionar información lícita y veraz, en los formularios y
                            enlaces habilitados en Nuestros Sitios, para el Acceso o realizar la compra del producto y/o
                            servicio. El Usuario tendrá un canal de comunicación con FAD vía whatsapp por medio de un
                            enlace que proporciona la página web, donde se le brindará soporte técnico o aclaración del
                            funcionamiento de la App y/o comunicarse con el equipo de ventas de FAD con horario de 10:00
                            a.m. a 8:00 p.m. de lunes a viernes.
                        </ol>
                    </li>
                    <br>

                    <li><span>RECOPILACIÓN DE INFORMACIÓN Y PROTECCIÓN DE DATOS PERSONALES</span> <br><br>
                        <ol type="a">
                            Para FAD es muy importante cuidar su información personal que nos proporciona directamente
                            en nuestra página de internet y/o Plataforma Digital y/o Redes Sociales, con cumplimiento a
                            lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de
                            Particulares, su Reglamento y los demás lineamientos nacionales e internacionales en materia
                            de Protección de Datos Personales nos comprometemos a cumplir con las medidas de seguridad:
                            Físicas, Administrativas y Técnicas. E informándole que el tratamiento de sus datos
                            personales será con apego a los principios que la Ley Federal de Protección de Datos
                            Personales en Posesión de Particulares y su Reglamento establecen. (consulte nuestras
                            políticas de privacidad en https://fad.firmaautografa.com/#/aviso-de-privacidad/ ).
                            <br>
                            El tratamiento de los datos personales de las terceras personas con las que Usted haga uso
                            de nuestros servicios serán responsabilidad suya y dicho tratamiento se regirá por su propio
                            aviso de privacidad.
                            <br>
                            Nosotros (FAD) desempeñamos la función de responsable de los datos personales durante el
                            tiempo de procesamiento de la Firma, quedando liberado al momento mismo de la destrucción
                            (supresión o eliminación) de los datos personales en nuestras bases de datos. Usted está de
                            acuerdo con la destrucción (supresión o eliminación) de estos los datos personales que
                            fueron utilizados en el proceso de la Firma FAD, también se compromete a mantener en paz, a
                            salvo y sin responsabilidad de los Datos Personales a FAD del tratamiento que Usted le da a
                            la información de sus Clientes y/o Personas Autorizadas, este tratamiento comprende previo a
                            la firma, durante el proceso de la firma en el FAD y del tratamiento posterior a éste.
                            <br><br>
                            <span>Enlaces externos en Nuestros Sitios.</span>
                            <br><br>
                            En nuestro sitio web www.firmaautografa.com incluye hipervínculos o enlaces que de terceros
                            distintos a FAD, el objetivo principal de estos enlaces es mejorar la experiencia del
                            Usuario permitiéndole Acceder a nuestro portal a través de Redes Sociales para solicitar
                            información y/o soporte técnico del FAD (vía Whatsapp) y método de pago (conekta), por lo
                            cual tampoco se garantizará la disponibilidad, exactitud, veracidad, validez o legalidad de
                            los sitios externos; FAD no asume ningún tipo de responsabilidad por los daños y perjuicios
                            que pudieran ocasionar el acceso o uso, de los contenidos, productos o servicios disponibles
                            a través de los enlaces o hipervínculos que no sean gestionados por FAD.
                            <br><br>
                            <span>Cookies.</span>
                            <br><br>
                            Le informamos a Usted que al ingresar a nuestro sitio web recabamos cookies, que son
                            archivos de texto pequeños encriptados que se encuentran dentro de su navegador, en nuestro
                            sitio web ayudan al usuario a realizar ciertas funciones como el método de búsqueda o inicio
                            de sesión, recordando el usuario y contraseña dentro de su navegador, recordar los productos
                            en el carrito de compras, recomendarle productos o servicios de acuerdo a su perfil; las
                            cookies facilitan este proceso de manera rápida y eficiente.
                            <br><br>
                            Las cookies que recabamos son las siguientes: <br>
                            · Para el Acceso al portal.<br>
                            · Para su navegación en Nuestros Sitios.<br>
                            · De Identificación.<br>
                            · Para su seguridad.<br>
                            · De complemento (plug-in).<br>
                            · De análisis.<br>
                            · Publicitario.<br>
                            · Propiedad.<br>
                            <br>
                            En caso de que Usted no desee que se recopile su información de esta manera, deberá
                            rechazar, deshabilitar o eliminar el uso de las cookies en su navegador de internet, podrá
                            hacerlo de la siguiente manera siendo usuario de Safari o Google Chrome:<br><br>
                            • Ingrese a preferencias<br>
                            • Busque privacidad del navegador.<br>
                            • Desactive o bloquee las cookies de: www.firmaautografa.com<br>
                        </ol>
                    </li>
                    <br>

                    <li><span>POLÍTICA DE PROPIEDAD INTELECTUAL DENTRO DE NUESTROS SITIOS.</span> <br><br>
                        <ol type="a">
                            Se considerará propiedad exclusiva de FAD, el software, la página web, la plataforma
                            digital, el diseño, los productos adicionales, algoritmos, marcas, y cualquier otro derecho
                            de propiedad intelectual relacionado con el servicio o productos software motivo de este
                            contrato.
                            <br>
                            Usted tiene estrictamente prohibido realizar cualquier tipo de reproducción, copia, puesta a
                            disposición a terceros, modificación, des-compilación, ajustes o cualesquiera otros actos
                            que vulneren los derechos de propiedad intelectual de FAD. La manipulación del sistema
                            constituye una violación a la Ley Federal del Derecho de Autor y dará lugar al pago de daños
                            y perjuicios por tal motivo y eximirá a FAD de toda responsabilidad sobre las fallas que
                            presente el sistema como consecuencia de dichas modificaciones no autorizadas.
                            <br>
                            FAD en este acto otorga a Usted una garantía contra todo problema de carácter legal que
                            pudiera ocasionar un tercero con relación a la propiedad o derecho de autor sobre el
                            servicio del software y productos adicionales que se ofertan en nuestra página web y
                            plataforma digital, objeto del presente contrato. En caso de producirse esta eventualidad,
                            Usted dará aviso por escrito a FAD para que asuma las acciones legales pertinentes.
                        </ol>
                    </li>
                    <br>

                    <li><span>GARANTÍAS Y EXENCIÓN DE LA RESPONSABILIDAD DE FAD.</span> <br><br>
                        <ol type="a">
                            Además de las exenciones de responsabilidad que hemos determinado en los Términos, nosotros
                            no otorgamos responsabilidad o garantía alguna en los siguientes casos:
                            <br><br>
                            I. Usted podrá cancelar el servicio de FAD en cualquier momento, advirtiéndole que no habrá
                            reembolsos por la cancelación. En el caso de suspensión del servicio, Usted acepta que no
                            recibirá ningún reembolso o compensación alguna.
                            <br><br>
                            II. Las deficiencias de su dispositivo electrónico que no cuente con la capacidad suficiente
                            de soporte o tecnológicas de FAD.
                            <br><br>
                            III. La violación asociada por el uso indebido y/o alteración al FAD y/o Nuestros Sitios,
                            que pudiera provocar el mal funcionamiento a su dispositivo electrónico, así como el de
                            terceras personas, tal como los defectos, las fallas, abuso, los accidentes, la negligencia,
                            la instalación, operación o mantenimientos inadecuados, vandalismo informático, los hechos
                            de fuerza mayor, los actos de terrorismo; las interrupciones o sobrecargas en suministro
                            eléctrico, fallas en su servicio de Internet, hechas por Usted.
                            <br><br>
                            IV. La incompatibilidad causada por algún competente de hardware y/o software instalado en
                            sus dispositivos electrónicos. Usted se compromete a Actualizar la Plataforma Digital de
                            FAD, cada que le sea notificado a través de correo electrónico, teléfono móvil, teléfono
                            fijo, por Whatsapp, Sitio web o cualquier medio de sus nuevas mejoras o versiones.
                            <br><br>
                            V. El uso ilícito de la plataforma, FAD no se hace responsable de la firma de documentos
                            ilícitos que Usted realice dentro de FAD, nos eximimos de cualquier responsabilidad legal
                            por el uso indebido que Usted dé ilícitamente con terceras personas o su personal dentro de
                            la empresa, ya que nosotros no tenemos la visibilidad del contenido dentro de los
                            documentos, solo tenemos acceso a los datos personales durante el proceso de la firma por
                            motivo de validación de ésta.
                            <br><br>
                            VI. Nosotros brindamos el soporte técnico y garantía de nuestros servicios, por consiguiente
                            si Usted no puede realizar el proceso de firma autógrafa digital y/o los productos
                            adicionales que Usted adquirió, por problemas técnicos en Nuestros Sitios que puedan surgir
                            por nosotros, FAD procederá el descuento de la cantidad de las firmas que no pudieron
                            realizarse. Esta garantía será aplicable siempre y cuando Usted notifique previamente al
                            área de soporte Técnico de FAD; esta garantía será válida para la contratación del servicio
                            de prepago con vigencia anual.
                            <br><br>
                            VII. De igual manera en FAD ofreceremos garantía de nuestros servicios, en la contratación
                            del servicio de suscripción mensual, otorgándole un día más del servicio por la firma que
                            Usted no logró concretar por problemas técnicos en Nuestros Sitios que puedan surgir por
                            nosotros.
                        </ol>
                    </li>
                    <br>

                    <li><span>PROPIEDAD INTELECTUAL</span> <br><br>
                        <ol type="a">
                            a. Titulares de derechos: FAD, es la única y exclusiva titular de los derechos de propiedad
                            intelectual de las marcas, avisos comerciales, secretos industriales, modelos de utilidad,
                            patentes, obras protegidas por el derecho de autor de cualquier naturaleza, contenidos
                            escritos, digitales, audiovisuales, y en cualquier formato que existan en la APP, en
                            términos de la Ley Federal del Derecho de Autor.
                            <br><br>
                            b. Queda estrictamente prohibida la reproducción parcial o total por cualquier medio de los
                            contenidos, así como la divulgación a cualquier tercero.
                            <br><br>
                            c. Asimismo, se le informa al usuario que tanto la información proporcionada en la APP así
                            como las transacciones efectuadas a través de ésta, son tratadas de manera confidencial
                            conforme a la ley de protección de datos personales en posesión de particulares.
                            <br><br>
                            d. Exclusión de responsabilidad: Nuestra APP se encuentra disponible “tal cual”, por lo que
                            el usuario declara su conformidad respecto de las características y contenido presentes, por
                            lo tanto, FAD se exime de toda responsabilidad respecto de la indisponibilidad de las
                            conexiones, enlaces o sus contenidos por cuestiones que no le sean directamente imputables,
                            por ejemplo: fallas en el servicio de internet o de datos, ataques externos, desastres
                            naturales, causas de fuerza mayor o baja de contenidos, o fallas imputables a los terceros
                            proveedores de servicios de cómputo en la nube, proveedores externos en su calidad de
                            administradores de la plataforma o intermitencias en la conexión a los mismos.
                            <br><br>
                            e. Licencia: FAD, otorga al Usuario, en este acto, una licencia de uso, no exclusiva,
                            temporal y gratuita, respecto de la aplicación móvil, por lo que cualquier otro derecho
                            queda reservado a FAD y podrá ejercer las acciones legales correspondientes en caso de
                            cualquier violación a sus derechos de propiedad intelectual.
                            <br><br>
                            f. Prohibiciones expresas: Queda expresamente prohibido cualquier tipo de modificación o
                            alteración de los contenidos, código, información y materiales de la APP, técnicas de
                            ingeniería de reversa, copia o reproducción parcial o total del contenido, distribución o
                            comunicación pública de éste por cualquier medio o en cualquier formato.
                        </ol>
                    </li>
                    <br>

                    <li><span>SEGURIDAD INFORMÁTICA Y LIMITACIÓN A LA RESPONSABILIDAD:</span> <br><br>
                        <ol type="a">
                            La seguridad informática en el uso de la APP depende en gran medida de la seguridad de la
                            red
                            mediante la cual acceda a ésta, le recomendamos no conectarse a nuestra aplicación móvil
                            utilizando
                            servicios públicos de Internet.
                            <br><br>
                            Hacemos de su conocimiento que FAD se encuentra alojada en los servidores de un prestador de
                            servicios de cómputo en la nube que cumple con los más altos estándares en materia de
                            seguridad de
                            la información.
                            <br><br>
                            Se recomienda ampliamente instalar un antivirus y antimalware en su dispositivo móvil para
                            evitar
                            que personas malintencionadas ejecuten programas maliciosos que puedan poner en riesgo la
                            información contenida en su equipo y la de sus comunicaciones.
                        </ol>
                    </li>
                    <br>

                    <li><span>MODIFICACIONES O ACTUALIZACIONES.</span> <br><br>
                        <ol type="a">
                            FAD podrá en cualquier momento y cuando lo considere conveniente, realizar correcciones,
                            adiciones,
                            mejoras o modificaciones al contenido, presentación, información, servicios, y demás
                            elementos, sin
                            que ello dé lugar ni derecho a ninguna reclamación o indemnización, ni que lo mismo implique
                            reconocimiento de responsabilidad alguna a favor del Usuario.
                        </ol>
                    </li>
                    <br>

                    <li><span>CONFIDENCIALIDAD DE LA INFORMACIÓN:</span> <br><br>
                        <ol type="a">
                            FAD utilizará la información proporcionada por el usuario de forma confidencial, la cual no
                            será difundida o transmitida para fines distintos a los establecidos en el presente
                            contrato, salvo que exista autorización expresa por parte del usuario.
                        </ol>
                    </li>
                    <br>

                    <li><span>RECLAMACIONES Y/O SOLICITUDES DE ACLARACIÓN:</span> <br><br>
                        <ol type="a">
                            En caso de reclamación y/o solicitud de aclaración respecto de los servicios de FAD, se
                            informa al usuario que podrá contactarse vía correo electrónico o bien podrá acudir al
                            domicilio, señalados en el punto 1 “Generales del proveedor” de los presentes términos y
                            condiciones.
                        </ol>
                    </li>
                    <br>

                    <li><span>PRÁCTICAS COMERCIALES:</span> <br><br>
                        <ol type="a">
                            FAD, no lleva a cabo prácticas comerciales engañosas, respecto de las características de sus
                            servicios; el funcionamiento de esta APP es conforme a los fines para los cuales fue creado.
                        </ol>
                    </li>
                    <br>

                    <li><span>LEGISLACIÓN Y JURISDICCIÓN APLICABLE.</span> <br><br>
                        <ol type="a">
                            Para lo relativo con la interpretación y cumplimiento de los Términos, adicionalmente las
                            condiciones derivadas de las Leyes : Ley Federal del Derecho de Autor, Ley Federal de
                            Protección a la Propiedad Industrial, Ley Federal de Protección al Consumidor, Código de
                            Comercio y Código Civil, sometiéndose a las disposiciones aplicables y vigentes de las demás
                            Leyes Federales y la jurisdicción de los Tribunales Federales de la Ciudad de México,
                            renunciando a cualquier fuero que por razón de sus domicilios presentes o futuros o por
                            cualquier circunstancia les pudiere corresponder.
                        </ol>
                    </li>

                </ol>
            </div>

        </div>
    </div>

</app-template>
